import api from './axios';

export const uploadCertificado = (id, file) => {
  const form = new FormData();
  form.append('file', file);
  return api.post(`/fit-tests/${id}/certificado`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then((r) => r.data);
};

export const downloadCertificado = async (id, nome) => {
  const response = await api.get(`/fit-tests/${id}/certificado`, { responseType: 'blob' });
  const url = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = nome || `certificado_${id}.pdf`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

export const deleteCertificado = (id) =>
  api.delete(`/fit-tests/${id}/certificado`);
